import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Encounter } from 'src/models';
import { ambientApi } from 'src/services';

export type UpdateEncounterByEhrIdPayload = {
  ehr_id?: string;
  encounter_status?: string;
  start_time?: string;
  created_at?: string;
  practitioner_id?: number;
  description?: string;
};

export type UseUpdateEncounterByEhrIdParams = {
  appointmentId: number;
  payload: UpdateEncounterByEhrIdPayload;
};

export type UpdateEncounterByEhrIdResponse = Encounter;

export const updateEncounterByEhrId = async (
  appointmentId: number,
  payload: UpdateEncounterByEhrIdPayload
): Promise<Encounter> => {
  const response = await ambientApi.put<Encounter>(
    `/encounters/appointments/${appointmentId}`,
    payload
  );
  return response.data;
};

export const useUpdateEncounterByEhrId = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: ['updateEncounterByEhrId'],
    mutationFn: ({ appointmentId, payload }: UseUpdateEncounterByEhrIdParams) =>
      updateEncounterByEhrId(appointmentId, payload),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['encounterList'] });
      queryClient.invalidateQueries({
        queryKey: ['encounterByEhrAppointmentId'],
      });
    },
  });
};
